import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets the distribution channel of the given `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{`.`}<br parentName="p"></br>{`
`}{`The `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{` price is updated as described in `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem-price-selection"
        }}>{`LineItem Price selection`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setLineItemDistributionChannel"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`lineItemId`}</inlineCode>{` - String - Required`}<br parentName="li"></br>
          {`ID of an existing `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitem"
          }}>{`LineItem`}</a>{` in the cart.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`distributionChannel`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#resourceidentifier"
          }}>{`ResourceIdentifier`}</a>{` of a `}<a parentName="li" {...{
            "href": "/api/../api/projects/channels#channel"
          }}>{`Channel`}</a>{` - Optional`}<br parentName="li"></br>
          {`If present a `}<a parentName="li" {...{
            "href": "/api/../api/types#reference"
          }}>{`Reference`}</a>{` to the channel will be set for the `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitem"
          }}>{`LineItem`}</a>{` specified by `}<inlineCode parentName="li">{`lineItemId`}</inlineCode>{`.
If not present the current `}<a parentName="li" {...{
            "href": "/api/../api/types#reference"
          }}>{`Reference`}</a>{` to a distribution channel will be removed from the `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitem"
          }}>{`LineItem`}</a>{` specified by `}<inlineCode parentName="li">{`lineItemId`}</inlineCode>{`.
The Channel must have the `}<inlineCode parentName="li">{`ProductDistribution`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/channels#channelroleenum"
          }}>{`ChannelRoleEnum`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      